<template>
  <span class="modern-color-theme font-poppins" :class="computedClass" :style="{ color }" :role="role" data-component-name="VSpan">
    <slot />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { ColorWithShade, Size } from '../../utils/types';
import { convertColorToCSSColorVariable } from '@component-utils/colors';

defineOptions({
  name: 'VSpan'
})

type FontWeightProps = 
  | { bold?: false; semibold: true }
  | { bold: true; semibold?: false }
  | { bold?: false; semibold?: false }

const props = withDefaults(
  defineProps<{
    size?: Size
    color?: ColorWithShade
    italic?: boolean
  } & FontWeightProps>(),
  {
    size: 'sm',
    color: 'neutral',
    bold: false,
    semibold: false,
    italic: false
  }
)

const computedClass = computed(() => {
  const styles = []

  if (props.size) styles.push(`text-${props.size}`)
  if (props.bold) styles.push('font-bold')
  if (props.semibold) styles.push('font-semibold')
  if (props.italic) styles.push('italic')

  return styles.join(' ')
})

const color = computed(() => convertColorToCSSColorVariable(props.color, 500))

const role = computed(() => {
  if (props.bold) return 'strong'
  else if (props.italic) return 'emphasis'
  else return undefined
})
</script>
